import React, { useEffect } from "react";
import usePopupStore from "../store/global";
export const fixPath = "../../../"
import usetranslatedTextStore from "../store/translatedText";

const Tttbutton = (props) => {
    const type = props.type
    const popupstore = usePopupStore()
    const {translatedText,setTranslatedText} = usetranslatedTextStore();
    const { setState, selectedTextArray } = popupstore
    useEffect(()=>{
        setState({bookType:type})
    },[])
    useEffect(() => {
        if (type === "epub") {
            let paragraphData = '';
            if (selectedTextArray.length > 0) {
                for (let i = 0; i < selectedTextArray.length; i++) {
                    paragraphData += selectedTextArray[i].string + ' ';
                }
                setState(
                    (state) => ({
                        ...state,
                        selectedText: paragraphData
                    })
                )
            }
        }else {

        }
    }, [selectedTextArray])

    const TTTbuttonClickHandler = () => {
        let data=null;
        if(type === 'epub'){ 
            data = window.ttt.createTextList() //in pagination_view_base 
            setState((state) => ({
                ...state,
                popupShown: true,
                translatedText:'',
                selectedTextArray: data,
                bookType: type
            }));
        } else{
            data = props.getSeletedText() // to be updated for pdf text
            setState((state) => ({
                ...state,
                popupShown: true,
                selectedText:data.selectedText.replaceAll("-\n",'').replaceAll("\n",''),
                selectedTextArray: data.selectedTextArray,
                bookType: type
            }));
    
        }
    }
    return (
        <>
            <button onClick={TTTbuttonClickHandler}
                className={(type == "epub") ? 'waves-effect waves-block waves-light' :
                    'Button ActionButton'}>
                {(type == "epub") ?
                    'Translate' :
                    <div className="Icon"><img src={fixPath + "themes/" + Config.THEME + "/images/TTT.svg"} /></div>}
            </button>
        </>
    );
};

export default Tttbutton;